import dayjs from 'dayjs'

import { LOCAL_STORAGE_KEY } from '@/constants/key'
import { sendEvent } from '@/libs/tmapLog'

const SESSION_STORAGE_KEY = '__cx_notice_shown_session'

function getStorageKey(boardKey: string): string {
  const today = dayjs().format('YYYYMMDD')
  return `${LOCAL_STORAGE_KEY.CX_NOTICE_HIDDEN_PREFIX}${boardKey}_${today}`
}

export function isNoticeHiddenToday(boardKey: string): boolean {
  try {
    return localStorage.getItem(getStorageKey(boardKey)) === 'true'
  }
  catch {
    return false
  }
}

export function hideNoticeToday(boardKey: string): void {
  try {
    localStorage.setItem(getStorageKey(boardKey), 'true')
  }
  catch {
    sendEvent('/faqmain/error_home_notice', 'set_local_storage')
  }
}

export function isNoticeShownInSession(): boolean {
  try {
    return sessionStorage.getItem(SESSION_STORAGE_KEY) === 'true'
  }
  catch {
    return false
  }
}

export function markNoticeShownInSession(): void {
  try {
    sessionStorage.setItem(SESSION_STORAGE_KEY, 'true')
  }
  catch {
    sendEvent('/faqmain/error_home_notice', 'set_session_storage')
  }
}
